const AUTH = {
    userAuthCookieName: "SomsClientAuth",
    rememberMeCookieName: "SomsUserName",
    envNameCookieName: "SomsEnvName",
    shouldSetup2FACookieName: "SomsShouldSetup2FA",
    googleMapsApiKey: "AIzaSyBjK7XnFe4XrEMiUHUx-EOSHEyFwemIMic" // GCP SubTrux Project http referrer restricted
};
export default AUTH;
